import {
  GridItem,
  Box,
  Image,
  Flex,
  Text,
  Badge,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Icon
} from "@chakra-ui/react";
import { CalendarIcon, AlgorithmIcon, CameraIcon } from "../../utils/icons";
import { formatDate, formatStatus, getStatusColor, getInfractionClassLabel } from "../../utils/formatters";

const PlateInfractionCard = ({ infraction, openImageModal, getAlgorithmName, getCameraName }) => {
  return (
    <GridItem w="100%" bg="white" boxShadow="md" borderRadius="md" overflow="hidden" transition="transform 0.2s, box-shadow 0.2s" _hover={{ transform: "translateY(-5px)", boxShadow: "lg" }}>
      <Box position="relative">
        {infraction.imageUrl ? (
          <Image
            src={infraction.imageUrl}
            alt={`Infração ${infraction.id}`}
            w="100%"
            h={{ base: "130px", md: "200px" }}
            objectFit="cover"
            onClick={() => openImageModal(infraction.imageUrl, infraction)}
            cursor="pointer"
          />
        ) : (
          <Flex
            w="100%"
            h="200px"
            bg="gray.200"
            justify="center"
            align="center"
          >
            <Text color="gray.500">Sem imagem</Text>
          </Flex>
        )}

        <Badge
          position="absolute"
          top="10px"
          right="10px"
          colorScheme={getStatusColor(infraction.status)}
          px={2}
          py={1}
          borderRadius="md"
          boxShadow="0 2px 5px rgba(0,0,0,0.2)"
        >
          {formatStatus(infraction.status)}
        </Badge>

        {infraction.plate && (
          <Badge
            position="absolute"
            top="10px"
            left="10px"
            colorScheme="teal"
            px={3}
            py={1}
            borderRadius="md"
            fontSize="md"
            fontWeight="bold"
            letterSpacing="wide"
            boxShadow="0 2px 5px rgba(0,0,0,0.2)"
          >
            {infraction.plate}
          </Badge>
        )}
      </Box>

      <Box p={{ base: 3, md: 4 }}>
        <Flex justify="space-between" align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap={2} mb={2}>
          <Badge
            colorScheme={infraction.confidence > 0.9 ? "green" : infraction.confidence > 0.7 ? "yellow" : "orange"}
            px={2}
            py={1}
            borderRadius="md"
            fontSize={{ base: "2xs", md: "xs" }}
          >
            Confiança: {(infraction.confidence * 100).toFixed(1)}%
          </Badge>
          <Badge
            colorScheme={"blue"}
            px={3}
            py={1}
            borderRadius="md"
            fontSize={{ base: "2xs", md: "xs" }}
          >
            Veículo: {infraction.vehicle_type}
          </Badge>
          {infraction.registeredVehicleType && (
            <Badge
              colorScheme="teal"
              px={2}
              py={1}
              borderRadius="md"
              fontSize={{ base: "2xs", md: "xs" }}
            >
              Cadastrada: {infraction.registeredVehicleType}
            </Badge>
          )}
          <Menu>
            <MenuButton as={Button} size="sm" variant="outline" width={{ base: "100%", md: "auto" }}>
              Ações
            </MenuButton>
            <MenuList>
              {/* Pode adicionar opções de menu futuras aqui */}
            </MenuList>
          </Menu>
        </Flex>

        <Flex mt={3} gap={3} wrap="wrap">
          <Flex align="center">
            <AlgorithmIcon color="blue.500" />
            <Text fontWeight="bold" fontSize={{ base: "xs", md: "sm" }} noOfLines={2}>
              {getInfractionClassLabel(infraction) || getAlgorithmName(infraction.algorithm_id)}
            </Text>
          </Flex>

          <Flex align="center">
            <CameraIcon color="green.500" />
            <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }} noOfLines={2}>
              {getCameraName(infraction.camera_id)}
            </Text>
          </Flex>
        </Flex>

        <Flex justify="space-between" mt={3} align={{ base: "flex-start", md: "center" }} direction={{ base: "column", md: "row" }} gap={2}>
          <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }}>
            <Icon as={CalendarIcon} mr={1} color="gray.500" />
            {formatDate(infraction.detected_at)}
          </Text>

          <Button
            size="xs"
            colorScheme="blue"
            variant="outline"
            onClick={() => openImageModal(infraction.imageUrl, infraction)}
          >
            Detalhes
          </Button>
        </Flex>
      </Box>
    </GridItem>
  );
};

export default PlateInfractionCard;